import React from "react";
import { STATUS } from "utils/constants/ui";
import InheritenceDisplay from "components/InheritenceDisplay";
import StatusIcon from "components/StatusIcon";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";

const AutoTaxSummary = ({ active, error }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <InheritenceDisplay
      title="Automatic taxes"
      error={error}
      onRemove={() => {
        setFieldValue(STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED, false);
        setFieldValue(STATE_KEYS.SHORT_LINK.TAX_RATES, []);
      }}
    >
      <div className="flex flex-row justify-between items-center">
        <div className="f6 word-break pr1">
          {active ? "Enabled" : "Disabled"}
        </div>
        {active && <StatusIcon status={STATUS.SUCCESS} size={20} />}
      </div>
    </InheritenceDisplay>
  );
};

export default AutoTaxSummary;
